import { range } from "lodash-es";

import { sntLog } from "src/app/common/logger";

const logger = sntLog("Json");
export function tryParseJson<T>(
  data: string | undefined | null,
  // @ts-ignore [expect-error]: 🐛 There is a null/undefined issue here which could cause bugs! Please fix me.
  defaultValue: T = undefined
): T | undefined {
  if (!data) {
    return defaultValue;
  }

  try {
    return JSON.parse(data);
  } catch (ex) {
    return defaultValue;
  }
}

export function tryEscapeAndParseJSON<T = any>(unsanitized: string): T {
  try {
    let sanitized = unsanitized
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r")
      .replaceAll("\\ ", "")
      .replace(/(?<!\\)\\(?!["\\/bfnrtu])/g, "\\\\")
      .replaceAll("\x00", "")
      .replaceAll("\x01", "")
      .replaceAll("\x02", "")
      .replaceAll("\x03", "")
      .replaceAll("\x04", "")
      .replaceAll("\x05", "")
      .replaceAll("\x06", "")
      .replaceAll("\x07", "")
      .replaceAll("\x08", "")
      .replaceAll("\x09", "");

    return JSON.parse(sanitized);
  } catch (ex) {
    logger.error(ex);
    // @ts-ignore [expect-error]: 🐛 There is a null/undefined issue here which could cause bugs! Please fix me.
    return undefined;
  }
}

export function getFormattedJSON(object: Object): string {
  return JSON.stringify(object, null, 4);
}
